import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutIsoScoreQuickInfo extends Layout {
    isoCarrierLabel: Label;
    panelQuickInfo: Panel;
    sourceCarriersForAssignment: DataSource;
    textboxId: Textbox;
    textboxKpiBouncedBookings: Textbox;
    textboxKpiOnTimeDelivery: Textbox;
    textboxKpiOnTimePickup: Textbox;
    textboxKpiScore: Textbox;
    textboxKpiTotalLoads: Textbox;
}
